@if (tile) {
  <mat-card class="understand-card"
    [ngClass]="{'understand-card--new-tile': tile.displayNewTile}"
    >
    @if (!tile.error && tile.loading) {
      <mat-card-content class="understand-card__loading">
        <content-placeholder></content-placeholder>
      </mat-card-content>
    }
    @if (!tile.loading) {
      <div>
        <mat-card-header class="understand-card__header-{{tile.category}}">
          <mat-card-title [attr.data-testid]="tile.title + '-title'" class="understand-card__title">
            {{tile.title}}
          </mat-card-title>
          @if (tile.displayNewTile && tile.newTileTooltip) {
            <button
              type="button"
              class="understand-card__new-tile"
              [matTooltip]="tile.newTileTooltip"
              matTooltipClass="automation-version-upgrade-tooltip"
              matTooltipPosition="below"
              matTooltipShowDelay="200"
              [attr.aria-label]="tile.newTileTooltip"
              [attr.data-testid]="tile.title + '-new-tile'">
              <span class="understand-card__new-tag">New!</span>
            </button>
          }
          <div fxFlex></div>
          @if (tile.helpText) {
            <help-text
              class="understand-card__help"
              [helpText]="tile.helpText"
              [displayOnLeft]="true">
            </help-text>
          }
        </mat-card-header>
        @if (tile.error) {
          <mat-card-content class="understand-card__error-content">
            <error-message class="understand-card__error"
              [error]="tile.error"
              [page]="getPageTitle()">
            </error-message>
          </mat-card-content>
        }
        @if (!tile.error) {
          <div>
            <mat-card-content
              class="understand-card__content"
              [ngClass]="{'understand-card__data-content': (hasData(tile.data) && !tile.drillDownDisabled)}">
              <ng-content></ng-content>
              @if (!hasData(tile.data)) {
                <div>
                  @if (tile.type !== 'externalLink') {
                    <div class="understand-card__no-data-message">
                      <span class="understand-card__top-message">No {{tile.title | titlecase}} data was found.</span>
                      <br>
                        <span class="understand-card__bottom-message">Try another date range or location.</span>
                      </div>
                    }
                    @if (tile.type === 'externalLink') {
                      <div class="understand-card__no-data-message">
                        <span class="understand-card__top-message">{{tile.text | titlecase}}</span>
                      </div>
                    }
                  </div>
                }
              </mat-card-content>
              @if (tile.id === 'topCampaignsByRedemptionRate') {
                <mat-card-content
                  [ngClass]="isMobile ? 'understand-card__top-campaigns-section-mobile' : 'understand-card__top-campaigns-section'">
                  @for (topCampaignsData of tile.data.redemptionStatsList; track (topCampaignsData.offerName || 'offer') + '|' + $index; let i = $index) {
                    <div fxFlex="100">
                      <mat-card class="understand-card__top-campaigns-card" (click)="onViewCampaignDetailsClicked(topCampaignsData)" (keydown.enter)="$event.target === $event.currentTarget && (onViewCampaignDetailsClicked(topCampaignsData))">
                        <mat-card-header class="understand-card__top-campaigns-section-header">
                          <mat-card-title [attr.data-testid]="topCampaignsData.offerName + '-title'" class="understand-card__title">
                            <img matListItemAvatar alt="Analytics Icon" class="understand-card__analytics-icon"
                              src="../../../assets/img/giving-gift.png">
                              <div class="understand-card__name-text"
                                [ngClass]="isMobile ? 'understand-card__name-text-mobile' : 'understand-card__name-text-desktop'"
                                [title]="topCampaignsData.offerName">
                              {{topCampaignsData.offerName}}
                            </div>
                          </mat-card-title>
                          <div fxFlex></div>
                        </mat-card-header>
                        <mat-card-content class="understand-card__top-campaigns-content">
                          <div class="understand-card__top-section">
                            <div fxLayout="column" class="understand-card__analytics-data-box">
                              <div fxLayout="row" class="understand-card__title-box">
                                <div class="understand-card__analytics-label">Check Average:</div>
                                <help-text class="understand-card__analytics-help-text"
                                [helpText]="checkAverageHelpText" [is3pSize]="true"></help-text>
                              </div>
                              <div>
                                <div class="understand-card__analytics-data" fxFlexAlign="end">
                                  {{topCampaignsData.totalCheckAverageLocation | currency:'USD':'symbol':'1.2-2'}}
                                </div>
                              </div>
                            </div>
                            <div fxLayout="column" class="understand-card__analytics-data-box">
                              <div fxLayout="row" class="understand-card__title-box">
                                <div class="understand-card__analytics-label">Sales Attached:</div>
                                <help-text class="understand-card__analytics-help-text"
                                [helpText]="salesAttachedHelpText" [is3pSize]="true"></help-text>
                              </div>
                              <div>
                                <div class="understand-card__analytics-data-sales" fxFlexAlign="end">
                                  {{topCampaignsData.totalSalesAttachedLocation | currency:'USD':'symbol':'1.2-2'}}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="understand-card__analytics-box">
                            <div fxLayout="row" fxLayoutAlign="start start">
                              <div fxLayout="column" fxFlex="75">
                                <div class="understand-card__analytics-label">
                                  Redemption Rate at My
                                  <span class="understand-card__analytics-label--tail">
                                    Location
                                    <help-text class="understand-card__analytics-help-text--inline"
                                      [displayOnLeft]="true"
                                      [helpText]="redemptionRateAtMyLocationHelpText"
                                      [is3pSize]="true">
                                    </help-text>
                                  </span>
                                </div>
                                <div fxLayout="row">
                                  <div fxLayout="column" fxFlex="45">
                                    <div class="understand-card__analytics-label">Total Issued:</div>
                                  </div>
                                  <div fxLayout="column" fxFlex="35">
                                    <div class="understand-card__analytics-data-small-font" fxFlexAlign="center">
                                      {{topCampaignsData.totalOffersIssued}}
                                    </div>
                                  </div>
                                </div>
                                <div fxLayout="row">
                                  <div fxLayout="column" fxFlex="45">
                                    <div class="understand-card__analytics-label">Redeemed:</div>
                                  </div>
                                  <div fxLayout="column" fxFlex="35">
                                    <div class="understand-card__analytics-data-small-font" fxFlexAlign="center">
                                      {{topCampaignsData.totalRedeemedSameLocation}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="understand-card__analytics-redemption-percentage" fxLayout="column" fxFlex="25"
                                         [ngClass]="{'understand-card__analytics-redemption-percentage-yellow': topCampaignsData.sameLocOffersRedeemPct <= .15,
                                 'understand-card__analytics-redemption-percentage-red': topCampaignsData.sameLocOffersRedeemPct < .10}">
                                        {{topCampaignsData.sameLocOffersRedeemPct | percent:'1.0-0'}}
                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                        @if (tile.buttonText && (hasData(tile.data) || tile.type === 'externalLink')) {
<button type="button" class="understand-card__bottom-button cfa-plain-button"
                             [attr.data-testid]="topCampaignsData.offerName + '-button'"
                            (click)="onViewCampaignDetailsClicked(topCampaignsData)"
                           >
                            {{tile.buttonText}}
                          </button>
                        }
                      </mat-card>
                    </div>
                  }
                </mat-card-content>
              }
            </div>
          }
          @if (tile.buttonText && (hasData(tile.data) || tile.type === 'externalLink') && tile.id !== 'topCampaignsByRedemptionRate') {
            <button type="button" class="understand-card__bottom-button cfa-plain-button"
              [attr.data-testid]="tile.title + '-button'"
              (click)="onClicked()"
             >
              {{tile.buttonText}}
              @if (tile.type === 'externalLink') {
                <i class="material-icons">open_in_new</i>
              }
            </button>
          }
        </div>
      }
    </mat-card>
  }
